import { Injectable } from '@angular/core';
import {
  CalculationTitleUpdateOptions,
} from '../../../../../../../../common/src/options/calculations/calculation-title-update.options';
import { FormFactory } from "@magieno/angular-advanced-forms";
import { AdvancedFormButton } from "@magieno/angular-advanced-forms";
import { ButtonStyleEnum } from '@magieno/angular-advanced-forms';
import { ButtonTypeEnum } from '@magieno/angular-advanced-forms';

@Injectable()
export class CalculationTitleUpdateFormFactory {
  constructor(private readonly formFactory: FormFactory) {
  }

  create() {
    return this.formFactory.create(new CalculationTitleUpdateOptions(), [
      new AdvancedFormButton('SAVE', ButtonStyleEnum.Primary, 'Sauvegarder', ButtonTypeEnum.Submit),
    ]);
  }
}
